import React from 'react';

export const ShutterRightFoldLeft = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 105.4 58.3"
      width="111"
      {...props}
    >
      <path fill="#fff" d="M5.5.6h94.4v50.8H5.5z" />
      <path
        d="M4.7 51.4V.6c0-.3.4-.6.8-.6h94.4c.4 0 .8.3.8.6v50.8c0 .3-.3.6-.8.6H5.5c-.4 0-.8-.3-.8-.6zM99.2 1.2H6.3v49.6h92.9V1.2z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M5.5.6h94.4v50.8H5.5z" />
      <path
        d="M4.7 51.4V.6c0-.3.4-.6.8-.6h94.4c.4 0 .8.3.8.6v50.8c0 .3-.3.6-.8.6H5.5c-.4 0-.8-.3-.8-.6zM99.2 1.2H6.3v49.6h92.9V1.2z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M9.9 3.9h85.6V48H9.9z" />
        <path d="M9.9 48.6c-.4 0-.8-.3-.8-.6V3.9c0-.3.3-.6.8-.6h85.6c.4 0 .8.3.8.6V48c0 .3-.3.6-.8.6H9.9zM94.8 4.5H10.7v42.9h84.1V4.5z" />
      </g>
      <path
        d="M.7 51.9h104c.4 0 .7-.2.7-.6 0-.3-.3-.6-.7-.6H.7c-.4 0-.7.2-.7.6 0 .4.3.6.7.6z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M100.1 1.3L73 7.6l-.1 49.9 27.2-6.8z" />
        <path
          d="M72.5 7L100.6.5v50.7l-28.2 7.1.1-51.3zm27.2-5L73.5 8.1l-.1 48.7 26.3-6.6V2z"
          fill="#fff"
        />
        <path fill="#233762" d="M97.3 7.1l-21.6 5.1v3.6l21.6-5.1z" />
        <path
          d="M75.5 11.9l22-5.2v4.2l-22.1 5.2.1-4.2zM97 7.5l-21 4.9v2.9l21-5V7.5z"
          fill="#fff"
        />
        <path fill="#233762" d="M97.3 10.7l-21.6 5.1v3.6l21.6-5.1z" />
        <path
          d="M75.5 15.5l22.1-5.2v4.2l-22.1 5.2v-4.2zM97 11.1l-21 5V19l21-5v-2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M97.3 14.3l-21.6 5.1v3.5l21.6-5.1z" />
        <path
          d="M75.5 19.1l22.1-5.2v4.2l-22.1 5.3v-4.3zM97 14.6l-21.1 5v2.9l21.1-5v-2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M97.3 17.8L75.7 23v3.6l21.6-5.2z" />
        <path
          d="M75.4 22.7l22.1-5.2v4.2L75.4 27v-4.3zM97 18.2l-21.1 5v2.9l21.1-5v-2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M97.3 21.4l-21.6 5.2v3.5L97.3 25z" />
        <path
          d="M75.4 26.3L97.5 21v4.2l-22.1 5.3v-4.2zM97 21.8l-21.1 5v2.9l21.1-5v-2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M97.3 25l-21.6 5.1v3.6l21.6-5.2z" />
        <path
          d="M75.4 29.9l22.1-5.3v4.2l-22.1 5.3v-4.2zM97 25.3l-21.1 5.1v2.9l21.1-5v-3z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M97.3 28.5l-21.6 5.2v3.6l21.6-5.2z" />
          <path
            d="M75.4 33.5l22.1-5.3v4.2l-22.1 5.4v-4.3zM97 28.9L75.9 34v2.9L97 31.8v-2.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M97.3 32.1l-21.6 5.2v3.6l21.6-5.2z" />
          <path
            d="M75.4 37.1l22.1-5.4v4.2l-22.1 5.4v-4.2zM97 32.5l-21.1 5.1v2.9L97 35.4v-2.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M97.3 35.7l-21.6 5.2v3.6l21.6-5.3z" />
          <path
            d="M75.4 40.7l22.1-5.4v4.2l-22.1 5.4v-4.2zM97 36l-21.1 5.2v2.9L97 39v-3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M97.3 39.3l-21.6 5.3-.1 3.6 21.7-5.4z" />
          <path
            d="M75.4 44.3l22.1-5.4v4.2l-22.1 5.5v-4.3zM97 39.6l-21.1 5.2v2.9L97 42.6v-3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M97.3 42.8l-21.7 5.4v3.6l21.7-5.4z" />
          <path
            d="M75.4 47.9l22.1-5.5v4.2l-22.1 5.5v-4.2zM97 43.2l-21.1 5.2v3L97 46.1v-2.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M87.1 9.5l-1.4.3v39.5l1.4-.4z" />
      </g>
      <g>
        <path fill="#233762" d="M71.9 7.3L44.1 1.2v49.5l27.8 6.8z" />
        <path
          d="M43.6.5l28.8 6.2v51.5l-28.8-7.1V.5zm27.8 7.3L44.6 2v48.3l26.8 6.6V7.8z"
          fill="#fff"
        />
        <path fill="#233762" d="M68.9 11.9L46.8 7.1v3.6l22.1 4.8z" />
        <path
          d="M46.6 6.7l22.6 5V16l-22.6-5V6.7zm22 5.5L47.1 7.5v2.9l21.5 4.8v-3z"
          fill="#fff"
        />
        <path fill="#233762" d="M68.9 15.5l-22.1-4.8v3.5l22.1 5z" />
        <path
          d="M46.6 10.3l22.6 5v4.3l-22.6-5.1v-4.2zm22 5.5L47.1 11v3l21.5 4.8v-3z"
          fill="#fff"
        />
        <path fill="#233762" d="M68.9 19.2l-22.1-5v3.6l22.1 5z" />
        <path
          d="M46.6 13.8l22.6 5v4.3L46.6 18v-4.2zm22 5.6l-21.5-4.8v2.9l21.5 4.9v-3z"
          fill="#fff"
        />
        <path fill="#233762" d="M68.9 22.8l-22.1-5v3.6l22.1 5z" />
        <path
          d="M46.6 17.4l22.6 5.1v4.3l-22.6-5.1v-4.3zm22 5.7l-21.5-4.9v2.9L68.6 26v-2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M68.9 26.4l-22.1-5V25l22.1 5z" />
        <path
          d="M46.6 21l22.6 5.1v4.3l-22.6-5.2V21zm22 5.7l-21.5-4.9v2.9l21.5 4.9v-2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M68.9 30l-22.1-5v3.5l22.1 5.1z" />
        <path
          d="M46.6 24.6l22.6 5.2V34l-22.6-5.2v-4.2zm22 5.7l-21.5-5v2.9l21.5 5v-2.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M68.9 33.6l-22.1-5.1v3.6l22.1 5.1z" />
          <path
            d="M46.6 28.1l22.6 5.2v4.3l-22.6-5.3v-4.2zm22 5.8l-21.5-5v2.9l21.5 5v-2.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M68.9 37.2l-22.1-5.1v3.6l22.1 5.2z" />
          <path
            d="M46.6 31.7L69.1 37v4.3L46.5 36l.1-4.3zm22 5.8l-21.5-5v2.9l21.5 5.1v-3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M68.9 40.9l-22.1-5.2v3.5l22.1 5.3z" />
          <path
            d="M46.6 35.3l22.6 5.3v4.3l-22.6-5.4v-4.2zm22 5.8L47.1 36v3l21.5 5.1v-3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M68.9 44.5l-22.1-5.3v3.6l22.1 5.3z" />
          <path
            d="M46.6 38.9l22.6 5.4v4.3l-22.6-5.4v-4.3zm22 5.9l-21.5-5.1v2.9l21.5 5.2v-3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M68.9 48.1l-22.1-5.3v3.6l22.1 5.3z" />
          <path
            d="M46.6 42.4l22.6 5.4v4.3l-22.6-5.5v-4.2zm22 6l-21.5-5.2v2.9l21.5 5.2v-2.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M58.4 9.6L57 9.3v39.5l1.4.4z" />
      </g>
      <g>
        <path fill="#233762" d="M38.4 7.3L5.5 1.2v49.5l32.9 6.8z" />
        <path
          d="M5 .5l34 6.3v51.5L5 51.2V.5zm32.8 7.3L6.1 2v48.3l31.7 6.6V7.8z"
          fill="#fff"
        />
        <path fill="#233762" d="M34.9 11.9L8.8 7.1v3.6l26.1 4.8z" />
        <path
          d="M8.5 6.7l26.7 5V16L8.5 11V6.7zm26.1 5.5L9.1 7.5v2.9l25.5 4.8v-3z"
          fill="#fff"
        />
        <path fill="#233762" d="M34.9 15.5L8.8 10.7v3.5l26.1 5z" />
        <path
          d="M8.5 10.3l26.7 5v4.3L8.5 14.5v-4.2zm26.1 5.5L9.1 11v3l25.5 4.8v-3z"
          fill="#fff"
        />
        <path fill="#233762" d="M34.9 19.2l-26.1-5v3.6l26.1 5z" />
        <path
          d="M8.5 13.8l26.7 5v4.3l-26.7-5v-4.3zm26.1 5.6L9.1 14.6v2.9l25.5 4.9v-3z"
          fill="#fff"
        />
        <path fill="#233762" d="M34.9 22.8l-26.1-5v3.6l26.1 5z" />
        <path
          d="M8.5 17.4l26.7 5.1v4.3L8.5 21.6v-4.2zm26.1 5.7L9.1 18.2v2.9L34.6 26v-2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M34.9 26.4l-26.1-5V25l26.1 5z" />
        <path
          d="M8.5 21l26.7 5.1v4.3L8.5 25.2V21zm26.1 5.7L9.1 21.8v2.9l25.5 4.9v-2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M34.9 30L8.8 25v3.5l26.1 5.1z" />
        <path
          d="M8.5 24.6l26.7 5.2V34L8.5 28.8v-4.2zm26.1 5.7l-25.5-5v2.9l25.5 5v-2.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M34.9 33.6L8.8 28.5v3.6l26.1 5.1z" />
          <path
            d="M8.5 28.1l26.7 5.2v4.3L8.5 32.3v-4.2zm26.1 5.8l-25.5-5v2.9l25.5 5v-2.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M34.9 37.2L8.8 32.1v3.6l26.1 5.2z" />
          <path
            d="M8.5 31.7L35.2 37v4.3L8.5 35.9v-4.2zm26.1 5.8l-25.5-5v2.9l25.5 5.1v-3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M34.9 40.9L8.8 35.7v3.5l26.1 5.3z" />
          <path
            d="M8.5 35.3l26.7 5.3v4.3L8.5 39.5v-4.2zm26.1 5.8L9.1 36v3l25.5 5.1v-3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M34.9 44.5L8.8 39.2v3.6l26.1 5.3z" />
          <path
            d="M8.5 38.9l26.7 5.4v4.3L8.5 43.1v-4.2zm26.1 5.9L9.1 39.6v2.9l25.5 5.2v-2.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M34.9 48.1L8.8 42.8v3.6l26.1 5.3z" />
          <path
            d="M8.5 42.4l26.7 5.4v4.3L8.5 46.6v-4.2zm26.1 6L9.1 43.2v2.9l25.5 5.2v-2.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M22.5 9.6l-1.7-.3v39.5l1.7.4z" />
      </g>
    </svg>
  );
};
